import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Venison,
  voices: {
    main: {
      description:
        "lean raspy tenor, feral woodland snarl, terse hunter focus, breath close to the mic, doubled animal undertone on shouts, rugged but articulate",
      seed: 10253,
      guidance: 0.76,
      loudness: 0.78,
      fx: { doubler: true },
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "We are Venison. You are insignificant." },
      { id: "select_2", text: "The symbiote hungers…" },
      { id: "select_3", text: "Venison awaits your command." },
      { id: "select_4", text: "Summon Venison, if you dare." },
    ],
    spawn: [
      { id: "spawn_1", text: "Come… Let us suck the marrow from their bones…" },
      { id: "spawn_2", text: "Let us feast together, Daywalker!" },
      { id: "spawn_3", text: "We no longer fear the fire…" },
      { id: "spawn_4", text: "Our bonds cannot be broken!" },
      {
        id: "spawn_5",
        text: "This fight is our destiny. It is why we were bonded together.",
      },
      {
        id: "spawn_6",
        text: "Knull brings nothing but darkness. His reign ends now.",
      },
      {
        id: "spawn_7",
        text: "If saving this universe means slaughtering our god, so be it.",
      },
      {
        id: "spawn_8",
        text: "Doom is nothing. Knull is the true threat, to this universe and all others.",
      },
      {
        id: "spawn_9",
        text: "We must protect the bond between space and time as fiercely as we protect our own.",
      },
      {
        id: "spawn_10",
        text: "We were once called a villain, but now the universe will see the hero we truly are.",
      },
      {
        id: "spawn_11",
        text: "The bond between a symbiote and its host is sacred. Do not dare to break it.",
      },
      {
        id: "spawn_12",
        text: "Finally, a chance to show them all who you were meant to be, Eddie.",
      },
      {
        id: "spawn_13",
        text: "This universe needs a different kind of protector. A lethal one.",
      },
      {
        id: "spawn_14",
        text: "We are done chasing spiders. We have bigger enemies to conquer.",
      },
      {
        id: "spawn_15",
        text: "We shall protect the innocent and devour the guilty!",
      },
      {
        id: "spawn_16",
        text: "Unlike other so-called heroes, we are not afraid to get our hands dirty.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "We have returned!" },
      { id: "respawn_2", text: "Venison lives!" },
      { id: "respawn_3", text: "You thought we were done?" },
      { id: "respawn_4", text: "You can' t get rid of us so easy." },
    ],
    ult_ally: [{ id: "ult_ally", text: "We hunger!" }],
    ult_enemy: [{ id: "ult_enemy", text: "We are Venison!" }],
    secondary: [
      { id: "secondary_1", text: "Not so fast." },
      { id: "secondary_2", text: "There is no escape!" },
      { id: "secondary_3", text: "You're ours now!" },
    ],
    ability2: [
      { id: "ability2_1", text: "Time to toughen up." },
      { id: "ability2_2", text: "We are protected now." },
      { id: "ability2_3", text: "Yes. That feels better!" },
    ],
    kill: [
      { id: "kill_1", text: "How delicious." },
      { id: "kill_2", text: "You're lucky we're a hero now." },
      { id: "kill_3", text: "Poor, pathetic thing." },
      { id: "kill_4", text: "We hope you suffered." },
      { id: "kill_5", text: "That was fun. For us." },
    ],
    multikill: [
      { id: "multikill_1", text: "Oops. We did it again." },
      { id: "multikill_2", text: "That's three. Who's next?" },
      { id: "multikill_3", text: "A three course meal. Yum." },
      { id: "multikill_4", text: "Five just seems greedy." },
      { id: "multikill_5", text: "No stopping us!" },
      {
        id: "multikill_6",
        text: "Maybe we should leave some for the others...",
      },
      { id: "multikill_7", text: "We've exterminated all of them!" },
      { id: "multikill_8", text: "A shame no one else pitched in." },
      { id: "multikill_9", text: "Really? We were just getting warmed up." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "We really needed that." },
      { id: "low_hp_2", text: "That should keep us going." },
    ],
    healed: [
      { id: "healed_1", text: "Back to full strength." },
      { id: "healed_2", text: "We feel much better." },
      { id: "healed_3", text: "This should help." },
      { id: "healed_4", text: "Just what we needed." },
    ],
  },
} satisfies VoiceScript;

export default script;
